export const setPaymentLocation = (location: string) =>
  sessionStorage.setItem("paymentLocation", location);

export const getPaymentLocation = () =>
  sessionStorage.getItem("paymentLocation");
